export const getBaseURL = () => {
	let baseURL = window.location.origin;

	if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
		baseURL = global.config.siteURL;
	}

	return baseURL;
}